import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/utils';

/** Standard page width + padding wrapper for content under the AppShell. */
export function ContentContainer({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('mx-auto w-full max-w-[1400px] p-4 md:p-6', className)}>{children}</div>;
}
